import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {Button} from 'antd';

import {DOC_OFFER_EN, DOC_OFFER_ES, LOGIN} from '../../../config/routes';

import cards from './cards.png'

import cls from './GetMoney.module.scss'

export const GetMoney = () => {

    const {t, i18n} = useTranslation();
    const navigate = useNavigate();

    const lang = i18n.language

    return (
        <div className={cls.block}>
            <div className={cls.content}>
                <h2>{t('Get money')}</h2>
                <div>
                    {t('The payment service on the GetMoney website is carried out in accordance with the Rules of the international payment systems Visa and MasterCard on the principles of confidentiality and security of payment, for which the most modern methods of verification, encryption and data transmission over closed communication channels are used. Bank card data is entered on the secure payment page FreedomPay. No one, including the company TOO "IT Consul" (https://togetmoney.kz), can obtain the bank and personal data of the payer.')}
                </div>
                <div className={cls.control}>
                    <Button size={'large'} onClick={() => navigate(lang === 'es' ? DOC_OFFER_ES : DOC_OFFER_EN)}>{t('Requisites')}</Button>
                    <Button size={'large'} onClick={() => navigate(LOGIN)}>{t('Login')}</Button>
                </div>
            </div>
            <div className={cls.image}>
                <img src={cards} alt={'Cards'}/>
            </div>
        </div>
    )
}